module.exports = __webpack_public_path__ + "img/imgloading.a81d6400.png";